import KatalLogger from '@amzn/katal-logger';

const userSuppliedFunctionNames = KATAL_USER_SUPPLIED_FUNCTION_NAMES;

export function createLogger() {
  const logger = new KatalLogger({
    url: LOGGER_URL,
    context: {
      katalComponentsPackageVersion: BRAZIL_PACKAGE_VERSION,
      katalComponentsBuildTime: KATAL_BUILD_TIME,
      location: window.location,
    },
    recordMetrics: false,
    decodeStackTrace: true,
  });
  return logger;
}

/* exported for testing */
export function filterError(error) {
  return (
    error?.stack?.includes('https://d1uznvntk80v7s.cloudfront.net') &&
    !userSuppliedFunctionNames.some(fn => error.stack.includes(fn))
  );
}
